<div>
    <div class="header-box">
        <div>
            <h1>
                ABC MERCHANT
            </h1>
        </div>
        <div>
            <img src="../../assets/image/bhim.jpg" alt="">
        </div>
    </div>
    <div class="btn-box">
        <button class="payment-mode">
            Payment Mode
        </button>
    </div>
    <div class="select-text">
        Select the payment mode to activate the selected plan
    </div>
    <div class="method-box">
        <img src="../../assets/image/bhim-icon.png" alt="">
        <span class="pay-text">
            Pay by any UPI app</span>
        <label for="debit">debit card</label>
        <input type="radio" id="debit"  value="credit" checked [(ngModel)]="paymentType" />
        <label for="credit">credit</label>
        <input type="radio" id="credit"  value="debit" [(ngModel)]="paymentType"/>
        <label for="netbanking">Netbanking</label>
        <input type="radio" id="netbanking"  value="netbanking" [(ngModel)]="paymentType"/>
    </div>
</div>